import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'partial/components/Button';
import EmptyState from 'partial/components/EmptyState';
import icon from 'assets/images/emessage-logo.png';

/* Carries the logo, then inherits the shared empty-state block. */
function PageNotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col items-center justify-center px-4">
      <img className="h-9 w-auto" src={icon} alt="eMessage Core" />
      <EmptyState
        glyph="results"
        statement="That page doesn’t exist."
        guidance="The link may be out of date, or the record may have been removed."
        action={
          <Button primary onClick={() => navigate('/')}>
            Go to dashboard
          </Button>
        }
        className="h-auto pt-6"
      />
    </div>
  );
}

PageNotFound.propTypes = {};

export default PageNotFound;
